// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"PopupContainer_popupContainer__E1l0g","popup":"PopupContainer_popup__nKfvC"};